import styled from 'styled-components';
import React from 'react';
import { Box, Typography } from '@mui/material';

const StyledInfoValue = styled(Box)(() => ({
    paddingLeft: '7px',
    fontWeight: 'bold'
}));

export const ProductDetailsContentStyled: React.FC<{
    name: string;
    value: string;
}> = (props) => {
    return (
        <Typography>
            <Box component="span">{props.name}:</Box>
            <StyledInfoValue component="span">{props.value}</StyledInfoValue>
        </Typography>
    );
};
